const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg',true,/\.svg$/)
requireAll(req)



// WEBPACK FOOTER //
// ./src/assets/svg.js